import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./listingCard.html";
import { FeatureFlags } from '~/modules/feature_flags';
import { i18nStore, WireI18n } from '~/modules/stores/i18nStore';
import { getListingLogoMediaId } from '~/modules/utilities/assetUtilities';
import { generateMediaUrl } from '~/modules/utilities/asset_utils';
class ListingCard extends LightningElement {
  constructor(...args) {
    super(...args);
    this.positionIndex = void 0;
    this.i18n = void 0;
  }
  set listingCardData(listing) {
    const {
      i18n
    } = i18nStore.getState();
    // HARD CODED MAX ON TAGS OF 2
    const tagMax = 2;
    this._listingCardData = {
      ...listing,
      positionIndex: this.positionIndex,
      image: this.getImageFromListing(listing),
      listingCategories: listing.listingCategories.filter(Boolean).slice(0, tagMax).map(category => {
        return {
          ...category,
          ariaLabel: i18n.shared.tagAriaLabel({
            CATEGORY_NAME: category.name
          }),
          id: `${listing.oafId}-${category.name?.replace(/ /g, '').trim()}`
        };
      })
    };
  }
  getImageFromListing(listingCardData) {
    if (listingCardData.logos) {
      const mediaId = getListingLogoMediaId(listingCardData.logos);
      if (mediaId) {
        return generateMediaUrl(mediaId);
      }
    }
    if (listingCardData.image) {
      return generateMediaUrl(listingCardData.image);
    }
    return undefined;
  }
  get altTextMessage() {
    const {
      i18n
    } = i18nStore.getState();
    return i18n.listingTile.altTextMessage({
      TITLE: this.listingCardData.title
    });
  }
  get listingCardData() {
    return this._listingCardData;
  }
  get screenReaderMessageForRating() {
    const {
      i18n
    } = i18nStore.getState();
    return i18n.listingTile.screenReaderRating({
      RATING: this.listingCardData.averageRating
    });
  }
  get chatLabel() {
    const {
      i18n
    } = i18nStore.getState();
    return i18n.listingCard.chatBadgeText();
  }
  get showChat() {
    return !FeatureFlags.FF_DISABLE_AUTO_LOAD_QUALIFIED_CHAT && this.listingCardData.chatEnabled;
  }
  get tags() {
    return this.listingCardData.listingCategories;
  }
  get cardFrameType() {
    return this.listingCardData.sponsored ? 'default' : 'elevation-2';
  }
  handleAnalytics(event) {
    event.detail.listing = this.listingCardData;
  }
  /*LWC compiler v7.1.3*/
}
ListingCard.delegatesFocus = true;
_registerDecorators(ListingCard, {
  publicProps: {
    positionIndex: {
      config: 0
    },
    listingCardData: {
      config: 3
    }
  },
  wire: {
    i18n: {
      adapter: WireI18n,
      config: function ($cmp) {
        return {};
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(ListingCard, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;